import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { createRef, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserInfo } from "src/core/auth/auth.service";
import ModalComponent from "src/core/components/modal/modal.component";
import HasPermission from "src/core/guards/has-permission";
import { B2Button } from "src/shared/@hdb/biome-2";
import FormBuilderComponent, {
  FormConfig,
} from "src/shared/form-builder/form-builder.component";
import ExecuteActionWithToaster from "src/shared/helpers/executeActionWithToaster";
import { displayToast } from "src/shared/helpers/toaster.helper";
import { sendGetCommandToDms } from "src/store/slices/asset.slice";
import * as yup from "yup";
import downloadIcon from "../../../../../assets/images/download.svg";
import {
  getMessageExchangedList
} from "../../../../../core/api/services/dms.device.service";
import TableComponent from "../../../../../core/components/table/table.component";
import InfoTileContainer from "../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../shared-elements/info-tile/info-tile.component";
import FilterFormComponent, {
  FilterFormConfig,
} from "../../../../../shared/filter-form/filter-form.component";
import { safeAtob } from "../../../../../shared/helpers/enode-decode-string";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import Title from "../../../../../shared/title/title.component";
import {
  getDeviceCertificateFile,
  renewCertificate,
  restrictCertificate,
  revokeCertificate,
} from "../../../../../store/slices/certificate.slice";
import { getDMSDeviceById, getActivityListByDeviceId as messageExchangedListSearch } from "../../../../../store/slices/dms-device.slice";
import "../../../admin.scss";
import SearchBarComponent from "../../search-bar/search-bar.component";
import "../dms.scss";

const DMSDeviceDetailsComponent = () => {
  const formRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [isRestrict, setIsRestrict] = useState<boolean>(false);
  const [isRevoke, setIsRevoke] = useState<boolean>(false);
  // const [isRenew, setIsRenew] = useState<boolean>(false);
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const dispatch = useDispatch();
  // const [alertPage, setAlertPage] = useState<number>(1);
  const [filterUpdateCount, setFilterUpdateCount] = useState(0);

  // const [activitiesPage, setActivitiesPage] = useState<number>(1);
  const [messageExchangedPage, setMessageExchangedPage] = useState<number>(1);
  const pageSize = 10;
  const [meSearchValue, setMeSearchValue] = useState("");
  // const [daSearchValue, setDaSearchValue] = useState("");
  // const [alSearchValue, setAlSearchValue] = useState("");
  const [filters, setFilters] = useState<any>({});

  // const [gatewayStatusData, setGatewayStatusData] = useState([] as any);
  const currentDateTime = moment().format("YYYY-MM-DD");
  const minDate = moment().subtract(7, "days").format("YYYY-MM-DD");
  const user = getUserInfo();

  const [formFilterInitialValues] = useState({
    StartDate: filters?.StartDate || "",
    EndDate: filters?.EndDate || "",
  });

  const [initialValues, setInitialValues] = useState<any>({
    expiredAt: "",
  });

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  useEffect(() => {
    const copiedSocketRealTimeUpdate = socketRealTimeUpdate
      ? structuredClone(socketRealTimeUpdate)
      : undefined;

    if (copiedSocketRealTimeUpdate?.FirmwareVersion) {
      if (
        user[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ] === socketData?.NotificationIdentifier
      ) {
        dispatch(getDMSDeviceById({ deviceId: id })).then((res: any) => {

          if (res?.payload) {
            displayToast(
              socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
              socketRealTimeUpdateData?.ToasterColor
            );
          }
        });
      }

    }
  }, [socketRealTimeUpdate]);

  const onRefetchData = () => {
    // setAlertPage(1);
    setMessageExchangedPage(1);
    // setActivitiesPage(1);
    dispatch(getDMSDeviceById({ deviceId: id }));

    // refetchAlertListOfSingleDevice();
    // refetchActivityList();
    void refetchMessageExchangeList();
  };

  /*   const [alertSortBy, setAlertSortBy] = useState<any>(
      capitalizeFirst("deviceCode")
    ); */
  // const [alertSortDirection, setAlertSortDirection] = useState<any>("desc");

  /*   const [alertColumns, setAlertColumns] = useState([
      {
        title: "Device ID",
        label: "deviceCode",
        isSorted: true,
      },
      {
        title: "Alert Type",
        label: "payload",
      },
      {
        title: "Timestamp",
        label: "slot_data",
        type: "datetime",
      },
      {
        title: "Details",
        label: "details",
      },
    ]); */

  const [meSortBy, setMeSortBy] = useState<any>(capitalizeFirst("alertType"));
  const [meSortDirection, setMeSortDirection] = useState<any>("desc");

  const [meColumns, setMeColumns] = useState([
    {
      title: "Message Type",
      label: "alertType",
      isSorted: true,
      width: "12rem",
    },
    {
      title: "Timestamp",
      label: "timeStamp",
      type: "datetime",
    },
    {
      title: "Details",
      label: "details",
    },
  ]);

  /*   const [daSortBy, setDaSortBy] = useState<any>(
      capitalizeFirst("activityType")
    );
    const [daSortDirection, setDaSortDirection] = useState<any>("desc");
  
    const [daColumns, setDaColumns] = useState([
      {
        title: "Activity Type",
        label: "activityType",
        isSorted: true,
        width: "12rem",
      },
      {
        title: "Timestamp",
        label: "timeStamp",
        type: "datetime",
      },
      {
        title: "Details",
        label: "details",
      },
    ]); */

  /*   const alertHandleChangeSort = useCallback(
      async (sortBy: string, sortDirection: any) => {
        if (!sortBy || !sortDirection) return;
        setAlertSortBy(sortBy);
        setAlertSortDirection(sortDirection);
  
        const copyColumns: any = await TableSort(alertColumns, sortBy);
        setAlertColumns(copyColumns);
      },
      []
    ); */

  const meHandleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setMeSortBy(sortBy);
      setMeSortDirection(sortDirection);

      const copyColumns: any = await TableSort(meColumns, sortBy);
      setMeColumns(copyColumns);
    },
    []
  );

  /*   const daHandleChangeSort = useCallback(
      async (sortBy: string, sortDirection: any) => {
        if (!sortBy || !sortDirection) return;
        setDaSortBy(sortBy);
        setDaSortDirection(sortDirection);
  
        const copyColumns: any = await TableSort(daColumns, sortBy);
        setDaColumns(copyColumns);
      },
      []
    ); */

  useEffect(() => {
    dispatch(getDMSDeviceById({ deviceId: id }));
  }, [dispatch, id]);

  const dmsDeviceDetails = useSelector((state: any) => {
    return state.dmsDevice.dmsDeviceDetails;
  });
  const isLoadingCommandToDms = useSelector((state: any) => {
    return state.asset.isLoadingCommandToDms;
  });

  const isLoadingDmsDeviceDetails = useSelector((state: any) => {
    return state.dmsDevice.isLoadingDmsDeviceDetails;
  });

  const filterFormConfig: FilterFormConfig = {
    controls: [
      {
        controlGroup: [
          {
            name: "StartDate",
            placeholder: "Select Start Date & Time",
            type: "datetime",
            required: true,
            isLoading: false,
            defaultTime: "12:00 AM",
            maxDate: currentDateTime,
            minDate: minDate,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "EndDate",
            placeholder: "Select End Date & Time",
            type: "datetime",
            required: true,
            isLoading: false,
            defaultTime: "11:59 PM",
            maxDate: currentDateTime,
            minDate: minDate,
          },
        ],
      },
    ],
  };

  /*   const {
    data: alertListOfSingleDevice,
    isLoading: isLoadingAlertListOfSingleDevice,
    refetch: refetchAlertListOfSingleDevice,
  } = useQuery({
    queryKey: [
      "getAlertListByDeviceId",
      alertPage,
      pageSize,
      id,
      alertSortBy,
      alertSortDirection,
      filters?.StartDate,
      filters?.EndDate,
      alSearchValue,
    ],
    queryFn: ({ signal }) =>
      getAlertListByDeviceId(
        alertPage,
        pageSize,
        id,
        alertSortBy,
        alertSortDirection,
        filters?.StartDate,
        filters?.EndDate,
        alSearchValue,
        signal
      ),
    enabled: !!alertPage,
    // enabled: !!filters.StartDate && !!filters.EndDate && !!id,
  }); */

  /*   const {
    data: activityList,
    isLoading: isLoadingActivityList,
    refetch: refetchActivityList,
  } = useQuery({
    queryKey: [
      "getActivityListByDeviceId",
      activitiesPage,
      pageSize,
      id,
      daSortBy,
      daSortDirection,
      filters?.StartDate,
      filters?.EndDate,
      daSearchValue,
    ],
    queryFn: ({ signal }) =>
      getActivityListByDeviceId(
        activitiesPage,
        pageSize,
        id,
        daSortBy,
        daSortDirection,
        filters?.StartDate,
        filters?.EndDate,
        daSearchValue,
        signal
      ),
    enabled: !!activitiesPage,
    // enabled: !!filters.StartDate && !!filters.EndDate && !!id
  }); */

  const {
    data: messageExchangeList,
    isLoading: isLoadingMessageExchangeList,
    refetch: refetchMessageExchangeList,
  } = useQuery({
    queryKey: [
      "getMessageExchangedList",
      messageExchangedPage,
      id,
      meSortBy,
      meSortDirection,
      filters?.StartDate,
      filters?.EndDate,
      meSearchValue,
    ],
    queryFn: ({ signal }) =>
      getMessageExchangedList(
        messageExchangedPage,
        pageSize,
        id,
        meSortBy,
        meSortDirection,
        filters?.StartDate,
        filters?.EndDate,
        meSearchValue,
        signal
      ),
    enabled: !!messageExchangedPage,
    // enabled: !!filters.StartDate && !!filters.EndDate && !!id
  });

  const onSubmitFilter = () => {
    const form: any = formRef.current;
    const { StartDate, EndDate } = form.values;
    form.handleSubmit();

    if (!StartDate || !EndDate) {
      return;
    }

    // check if startdate with time is less than current date
    if (moment(EndDate).isAfter(moment(), "day")) {
      form.setFieldError("EndDate", "End date must be within today's date");
      return;
    }

    // check if enddate with time is grater than startdate with time
    const startDateTime = moment(StartDate).format("YYYY-MM-DD HH:mm:ss");
    const endDateTime = moment(EndDate).format("YYYY-MM-DD HH:mm:ss");
    if (moment(endDateTime).isBefore(startDateTime)) {
      form.setFieldError("EndDate", "End Date must be greater than Start Date");
      return;
    }
    // setFilters({ ...form.values, StartDate: startDateTime, EndDate: endDateTime });

    setFilters(form.values);
    // setFormFilterInitialValues(form.values);
    onRefetchData();
  };

  const filterActionConfig: any = {
    label: "Filter",
    event: onSubmitFilter,
    variant: "primary",
  };

  /*   const handleAlertChangePage = useCallback((page: number): void => {
      setAlertPage(page);
    }, []);
  
    const handleActivityPageChange = useCallback((page: number): void => {
      setActivitiesPage(page);
    }, []); */

  const handleMessageExchangePageChange = useCallback((page: number): void => {
    setMessageExchangedPage(page);
  }, []);

  //
  const meHandleSearch = useCallback((searchVal: string): void => {
    setMeSearchValue(searchVal);
  }, []);

  /*   const daHandleSearch = useCallback((searchVal: string): void => {
      setDaSearchValue(searchVal);
    }, []);
  
    const alHandleSearch = useCallback((searchVal: string): void => {
      setAlSearchValue(searchVal);
    }, []); */

  const onClickDownload = (certificateType: string) => {
    dispatch(
      getDeviceCertificateFile({
        certificateId: dmsDeviceDetails?.certificateId || 0,
        certificateType,
      })
    );
  };

  const onReset = () => {
    const form: any = formRef.current;
    //  ;
    form.resetForm({
      values: { StartDate: "New Name" },
    });
    setFilters({});
    setFilterUpdateCount(filterUpdateCount + 1);
    onRefetchData();
  };

  const reset: any = {
    label: "Reset",
    event: onReset,
    variant: "secondary",
  };

  const validationSchema = yup.object().shape({
    StartDate: yup.date().required("Start Date is required"),
    EndDate: yup
      .date()
      .required("End Date is required")
      .typeError("Invalid End Date")
      .test(
        "is-within-today",
        "End Date must be within today's date",
        function (value) {
          const currentDateTime = moment().endOf("day"); // End of today
          return value ? moment(value).isSameOrBefore(currentDateTime) : true;
        }
      )
      .test(
        "is-greater",
        "End Date must be greater than Start Date",
        function (value, context) {
          const { StartDate } = context.parent; // Access StartDate from the same form
          return value && StartDate
            ? new Date(value) > new Date(StartDate)
            : true;
        }
      ),
  });

  const validationSchemaForDownload = yup.object().shape({
    expiredAt: yup.date().required("Expired At is required"),
  });

  /* useEffect(() => {
    setGatewayStatusData([
      {
        title: "Status",
        content: dmsDeviceDetails?.certstatus || "-",
      },
      {
        title: "Asset ID",
        content: dmsDeviceDetails?.deviceCode || "-",
      },
      {
        title: "Asset Type",
        content: dmsDeviceDetails?.assetType || "-",
      },
      {
        title: "Light Type",
        content: dmsDeviceDetails?.lightType || "-",
      },
      {
        title: "Vendor",
        content: dmsDeviceDetails?.vendor || "-",
      },
      {
        title: "Town Council",
        content: dmsDeviceDetails?.tcName || "-",
      },
      {
        title: "Site",
        content: dmsDeviceDetails?.siteName || "-",
      },
      {
        title: "Block",
        content: dmsDeviceDetails?.blockCode || "-",
      },
      {
        title: "Floor",
        content: dmsDeviceDetails?.floorName || "-",
      },
      {
        title: "Area",
        content: dmsDeviceDetails?.area || "-",
      },
    ]);
  }, [dmsDeviceDetails]); */

  ///////

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);

    setInitialValues({
      expiredAt: "",
    });
  };

  const downloadAction = () => {
    setIsModalOpen(true);
    setIsDownload(true);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);
  };

  const restrictAction = () => {
    setIsModalOpen(true);
    setIsDownload(false);
    setIsRestrict(true);
    setIsRevoke(false);
    // setIsRenew(false);
  };

  const revokeAction = () => {
    setIsModalOpen(true);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(true);
    // setIsRenew(false);
  };

  const renewAction = () => {
    setIsModalOpen(true);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(true);
  };

  const handleRestrictOk = () => {
    setIsModalOpen(false);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);

    setInitialValues({
      expiredAt: "",
    });

    dispatch(
      restrictCertificate({ certificateId: dmsDeviceDetails?.certificateId }) // dmsDeviceDetails?.deviceCode
    ).then(() => {
      onRefetchData();
    });
  };

  const handleRevokeOk = () => {
    setIsModalOpen(false);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);

    setInitialValues({
      expiredAt: "",
    });

    dispatch(
      revokeCertificate({ certificateId: dmsDeviceDetails?.certificateId })
    ).then(() => {
      onRefetchData();
    });
  };

  const onSubmitRenew = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();

      const formValues = form.values;
      const payload = {
        ...formValues,
        certificateId: dmsDeviceDetails?.certificateId,
      };

      dispatch(renewCertificate({ payload })).then(() => {
        onRefetchData();
      });
    }

    handleCloseModal();
  };

  let modalActionConfig: any;

  if (isDownload) {
    modalActionConfig = [
      {
        label: "Ok",
        event: handleCloseModal,
        variant: "primary",
      },
    ];
  } else if (isRestrict) {
    modalActionConfig = [
      {
        label: "Yes",
        event: handleRestrictOk,
        variant: "primary",
      },
    ];
  } else if (isRevoke) {
    modalActionConfig = [
      {
        label: "Yes",
        event: handleRevokeOk,
        variant: "primary",
      },
    ];
  } else {
    modalActionConfig = [
      {
        label: "Ok",
        event: onSubmitRenew,
        variant: "primary",
      },
    ];
  }

  const formConfig: FormConfig = {
    controls: [
      {
        name: "expireDate",
        label: "Expired At",
        placeholder: "Select Expiration Date",
        type: "date",
        required: true,
      },
    ],
  };

  useEffect(() => {
    // setAlertPage(1);
    setMessageExchangedPage(1);
    // setActivitiesPage(1);
  }, [filters]);

  const getFirmwareVersion = async () => {

    await ExecuteActionWithToaster(
      dispatch,
      sendGetCommandToDms({
        assetCode: dmsDeviceDetails?.deviceCode,
        module: 17,
      })
    );

    // if (res?.error) {
    //   return;
    // } else {
    //   //
    //   dispatch(getDMSDeviceById({ deviceId: id })).then((res: any) => {
    //     const response = res?.payload;
    //     if (response) {
    //       toast.success(
    //         `Firmware Version: ${response.firmwareVersion || 0.0}`,
    //         {
    //           position: "top-right",
    //           autoClose: 3000,
    //           hideProgressBar: false,
    //           closeOnClick: false,
    //           pauseOnFocusLoss: true,
    //           draggable: true,
    //           pauseOnHover: true,
    //         }
    //       );
    //     }
    //   });
    // }


  };

  let certificateTitle = "Download Certificate";
  if (dmsDeviceDetails?.certstatus === "Restricted") {
    certificateTitle = "Certifcate is Restricted";
  } else if (dmsDeviceDetails?.certstatus === "Invalid") {
    certificateTitle = "Certificate is Invalid";
  } else if (dmsDeviceDetails?.certstatus === "Revoked") {
    certificateTitle = "Certificate is revoked";
  }

  let modalHeaderTitle = "Renew Certificate";
  if (isDownload) {
    modalHeaderTitle = "Download Certificates";
  } else if (isRestrict) {
    modalHeaderTitle = "Confirm Restrict Certificate";
  } else if (isRevoke) {
    modalHeaderTitle = "Confirm Revoke Certificate";
  }

  let modalBody;
  if (isDownload) {
    modalBody = (
      <ul className="list-unstyled">
        <li>
          <button
            type="button"
            className="cursor-pointer text-decoration-underline border-0 bg-transparent p-0"
            onClick={() => onClickDownload("ca")}
          >
            <FontAwesomeIcon icon={faFileArrowDown} className="me-2 fs-5" />
            Download CA Certificate
          </button>
        </li>
        <li className="my-3">
          <button
            type="button"
            className="cursor-pointer text-decoration-underline border-0 bg-transparent p-0"
            onClick={() => onClickDownload("device")}
          >
            <FontAwesomeIcon icon={faFileArrowDown} className="me-2 fs-5" />
            Download Device Certificate
          </button>
        </li>
        <li>
          <button
            type="button"
            className="cursor-pointer text-decoration-underline border-0 bg-transparent p-0"
            onClick={() => onClickDownload("key")}
          >
            <FontAwesomeIcon icon={faFileArrowDown} className="me-2 fs-5" />
            Download Certificate Key
          </button>
        </li>
      </ul>
    );
  } else if (isRestrict) {
    modalBody = (
      <p>
        If you restrict the certificate then the gateway will no longer be able
        to connect the <br /> system until enabled back. Do you really want to
        proceed?
      </p>
    );
  } else if (isRevoke) {
    modalBody = (
      <p>
        If you revoke the certificate this will disconnect the gateway from the
        system. And the gateway <br /> will no longer be able to connect until
        new certificate issued. Do you really want to proceed?
      </p>
    );
  } else {
    modalBody = (
      <FormBuilderComponent
        formRef={formRef}
        initialValues={initialValues}
        validation={validationSchemaForDownload}
        formConfig={formConfig}
      />
    );
  }

  return (
    <div className="d-flex justify-content-center gap-4">
      <div className="w-100">
        <Title title="Overview" />

        <div className="my-3">
          <div className="asset-details">
            <InfoTileContainer header="Device Details">
              <InfoTileComponent
                title="Device ID"
                value={dmsDeviceDetails?.deviceCode}
                valueWidth={4}
                isLoading={isLoadingDmsDeviceDetails}
              />
              <InfoTileComponent
                title="Display Name"
                value={dmsDeviceDetails?.deviceDisplayName}
                valueWidth={4}
                isLoading={isLoadingDmsDeviceDetails}
              />
              <InfoTileComponent
                title="Device Type"
                value={dmsDeviceDetails?.assetType}
                isLoading={isLoadingDmsDeviceDetails}
              />
              <InfoTileComponent
                title="Firmware Version"
                value={dmsDeviceDetails?.firmwareVersion}
                isLoading={isLoadingDmsDeviceDetails || isLoadingCommandToDms}
                isRefreshButton={true}
                onClick={getFirmwareVersion}
              />
            </InfoTileContainer>

            <InfoTileContainer header="Location Details">
              <InfoTileComponent
                title="Town Council"
                value={dmsDeviceDetails?.tcName}
                isLoading={isLoadingDmsDeviceDetails}
              />
              <InfoTileComponent
                title="Address"
                value={dmsDeviceDetails?.address}
                isLoading={isLoadingDmsDeviceDetails}
              />
              <InfoTileComponent
                title="Level"
                value={dmsDeviceDetails?.floorName}
                isLoading={isLoadingDmsDeviceDetails}
              />
            </InfoTileContainer>
          </div>
        </div>

        {/* alert table */}

        <div className="mb-3 mt-5">
          <Title title="Message Exchange" />
        </div>

        <div>
          <FilterFormComponent
            formRef={formRef}
            initialValues={formFilterInitialValues}
            formConfig={filterFormConfig}
            actionConfig={filterActionConfig}
            validation={validationSchema}
            resetButton={reset}
            filterUpdateCount={filterUpdateCount}
          />
        </div>

        {/* Alert List */}
        {/* <div className=" p-2">
          <h2>Alerts</h2>
        </div>

        <div>
          <div className="my-3 ">
            <div className="d-flex gap-3 justify-content-end table-generic-action pb-3">
              <SearchBarComponent
                placeholder="Search Alert"
                methodToDispatch={alertListSearch}
                getSearch={alHandleSearch}
              />
            </div>
            <TableComponent
              tableHeaders={alertColumns}
              data={alertListOfSingleDevice?.data}
              totalNumberOfRecords={alertListOfSingleDevice?.numberOfRecords}
              pageSize={pageSize}
              current={alertPage}
              onChangePage={handleAlertChangePage}
              onChangeSort={alertHandleChangeSort}
              isLoadingData={isLoadingAlertListOfSingleDevice}
            />
          </div>
        </div> */}

        {/* <div>
          <h4 className="mt-4">Activities</h4>
          <div className="my-3">
            <div className="d-flex gap-3 justify-content-end table-generic-action pb-3">
              <SearchBarComponent
                placeholder="Search Activity"
                methodToDispatch={activityListSearch}
                getSearch={daHandleSearch}
              />
            </div>

            <TableComponent
              tableHeaders={daColumns}
              data={activityList?.data}
              totalNumberOfRecords={activityList?.numberOfRecords}
              pageSize={pageSize}
              current={activitiesPage}
              onChangePage={handleActivityPageChange}
              onChangeSort={daHandleChangeSort}
              isLoadingData={isLoadingActivityList}
            />
          </div>
        </div> */}

        {/* device list table */}
        <div>
          {/* <h4 className="mt-4">Message Exchanged</h4> */}
          <div className="my-3">
            <div className="d-flex gap-3 justify-content-end table-generic-action pb-3 table-toolbar">
              <SearchBarComponent
                placeholder="Search Message"
                methodToDispatch={messageExchangedListSearch}
                getSearch={meHandleSearch}
              />
            </div>

            <TableComponent
              tableHeaders={meColumns}
              data={messageExchangeList?.data}
              totalNumberOfRecords={messageExchangeList?.numberOfRecords}
              pageSize={pageSize}
              current={messageExchangedPage}
              onChangePage={handleMessageExchangePageChange}
              onChangeSort={meHandleChangeSort}
              isLoadingData={isLoadingMessageExchangeList}
            />
          </div>
        </div>

        <HasPermission
          moduleName="Device"
          actionName="Edit-Device"
          isRoute={false}
        >
          {dmsDeviceDetails?.certstatus && (
            <div>
              <Title title={certificateTitle} />

              <div className="bg-card keep-padding shadow-sm d-flex justify-content-center align-items-center gap-4 flex-wrap mt-3">
                {/* if not restricted and valid let user download */}

                <B2Button
                  variant="light"
                  onClick={downloadAction}
                  disabled={
                    dmsDeviceDetails?.certstatus === "Restricted" ||
                    dmsDeviceDetails?.certstatus === "Invalid" ||
                    dmsDeviceDetails?.certstatus === "Revoked"
                  }
                >
                  <img
                    className="fs-7 me-1"
                    src={downloadIcon}
                    alt="PDF Icon"
                  />
                  {" "}Download Certificate
                </B2Button>

                {/* if valid let user do download, restrict, revoke, renew*/}

                <B2Button
                  variant="light"
                  onClick={restrictAction}
                  disabled={
                    dmsDeviceDetails?.certstatus === "Restricted" ||
                    dmsDeviceDetails?.certstatus === "Invalid" ||
                    dmsDeviceDetails?.certstatus === "Revoked"
                  }
                >
                  <img
                    className="fs-7 me-1"
                    src={downloadIcon}
                    alt="PDF Icon"
                  />
                  {" "}Restrict Certificate
                </B2Button>

                <B2Button
                  variant="light"
                  onClick={revokeAction}
                  disabled={
                    dmsDeviceDetails?.certstatus === "Restricted" ||
                    dmsDeviceDetails?.certstatus === "Invalid" ||
                    dmsDeviceDetails?.certstatus === "Revoked"
                  }
                >
                  <img
                    className="fs-7 me-1"
                    src={downloadIcon}
                    alt="PDF Icon"
                  />
                  {" "}Revoke Certificate
                </B2Button>

                {["Valid", "Invalid", "Revoked"].includes(
                  dmsDeviceDetails?.certstatus
                ) && (
                    <B2Button
                      variant="light"
                      onClick={renewAction}
                      disabled={
                        dmsDeviceDetails?.certstatus === "Restricted" ||
                        dmsDeviceDetails?.certstatus === "Invalid" ||
                        dmsDeviceDetails?.certstatus === "Revoked"
                      }
                    >
                      <img
                        className="fs-7 me-1"
                        src={downloadIcon}
                        alt="PDF Icon"
                      />
                      {" "}Renew Certificate
                    </B2Button>
                  )}
              </div>
            </div>
          )}
        </HasPermission>

        {/* modals */}

        {isModalOpen && (
          <ModalComponent
            isConformationModal={isRestrict || isRevoke}
            showModal={isModalOpen}
            handleClose={handleCloseModal}
            headerTitle={modalHeaderTitle}
            actionConfig={modalActionConfig}
          >
            {modalBody /* isDownload, isRestrict, and isRevoke are handled above */}
          </ModalComponent>
        )}
      </div>
    </div>
  );
};

export default DMSDeviceDetailsComponent;
